// ABOUTME: Page layout component with cyberpunk-themed design
// ABOUTME: Provides consistent layout structure with gradient background and navigation
import NavBar from "./NavBar";

type Props = {
    children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({children}) => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-purple-900 via-blue-900 to-black overflow-hidden relative">
            {/* Animated grid background */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXR0ZXJuIGlkPSJncmlkIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPjxwYXRoIGQ9Ik0gODAgMCBMIDAgMCAwIDgwIiBmaWxsPSJub25lIiBzdHJva2U9IiMzOTM5NzkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIiAvPjwvc3ZnPg==')] opacity-30 animate-pulse"></div>

            <div className="relative z-10">
                <NavBar />
                <div className="container mx-auto px-4 py-8">
                    {children}
                </div>
            </div>

            {/* Animated light streaks */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {[...Array(5)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-70 animate-light-streak"
                        style={{
                            top: `${Math.random() * 100}%`,
                            left: 0,
                            right: 0,
                            animationDelay: `${Math.random() * 2}s`
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
};